export const months = [
  "januari",
  "februari",
  "maart",
  "april",
  "mei",
  "juni",
  "juli",
  "augustus",
  "september",
  "oktober",
  "november",
  "december"
];

export const days = ["MA", "DI", "WO", "DO", "VR", "ZA", "ZO"];
